export var SelectLabelAppearance;
(function (SelectLabelAppearance) {
    SelectLabelAppearance["UNRESPONSIVE"] = "unresponsive";
    SelectLabelAppearance["INLINE"] = "inline";
})(SelectLabelAppearance || (SelectLabelAppearance = {}));
//# sourceMappingURL=oh-select.types.js.map
